import { Block } from '../block.js'
import {
	jsonClass,
	jsonProperty,
	jsonArrayProperty,
} from '@sumbricht/json-class-serializer'
import { ScreenEditorInput } from '../decorators/screen-editor-input.js'
import type { Direction } from '../../types.js'
import type { DirectionOptions } from '../../types.js'
import { NavigationItemBlock } from './navigation-item-block.js'

@jsonClass('NavigationListBlock')
export class NavigationListBlock extends Block {
	readonly allowedChildTypes = [NavigationItemBlock]

	constructor(init: Partial<NavigationListBlock> = {}) {
		super()
		this.init(init)
	}

	getEditorCategory(): string {
		return 'Screen Structure'
	}

	static createNewForEditor(): Block {
		return new this({
			children: [NavigationItemBlock.createNewForEditor()],
		})
	}
}
